/*
 * Legacy asset stub.
 *
 * KwikPass is installed/managed through the Shopify theme app embed and must
 * handle account/login interception and popup behavior itself. This legacy
 * asset intentionally contains no account, popup, Lucent, simplyOtp, or
 * KwikPass click-handler logic.
 */
(function () {
  'use strict';
}());
